import { call, put, select } from 'redux-saga/effects';
import Modal from '@bitComponents/unifiedComponents/Modal';
import { checkOBD as checkOBDBit } from '../bitSagas/checkOBD';
import { getOBD as getOBDBit } from '../bitSagas/getOBD';
import { validateOBDPin as validateOBDPinBit } from '../bitSagas/validateOBDPin';
import { generateOBDPin as generateOBDPinBit } from '../bitSagas/generateOBDPin';
import { actions as apisNeedsActions } from '../reducers/apisNeeds';
import { actions as obdActions } from '../reducers/obd';
import { actions as uiNeedsActions } from '../reducers/uiNeeds';
import { commonActions } from '../reducers/common';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';

const uiNeedsStore = state => state.uiNeeds;

function* setValidLinesIntoRedux(validLines) {
  if (!validLines || !validLines.length || validLines.length === 0) {
    yield put(uiNeedsActions.removeNonOneClickStep());
  } else {
    yield put(commonActions.setObdLines(validLines));
  }
}

export function* getOBD(input) {
  const reduxUpdate = {};

  const getOBDParams = {
    ...input,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(getOBDBit, getOBDParams);
    yield call(setValidLinesIntoRedux, response);
  } catch (e) {
    yield call(setValidLinesIntoRedux);
    return null;
  }

  return response;
}

export function* checkOBD(input) {
  const reduxUpdate = {};

  const checkOBDParams = {
    ...input,
    reduxUpdate,
  };

  let response = null;
  try {
    response = yield call(checkOBDBit, checkOBDParams);

    const { onBoardingActivo } = response;

    if (onBoardingActivo) {
      yield put(apisNeedsActions.setActiveOBD());
      return megaMinderStatus.OK;
    }

    yield call(getOBD, input);
  } catch (e) {
    yield call(setValidLinesIntoRedux);
    return null;
  }

  return response;
}

export function* generateOBDPin(input) {
  const reduxUpdate = {};

  const {
    securityMediumType,
    verifiedContactMeanId,
    subscribedLineId,
  } = input.payload;

  const generateOBDPinData = {
    securityMediumType,
    verifiedContactMeanId,
    subscribedLineId,
    verificarContacto: false,
  };

  const generateOBDPinParams = {
    ...input,
    reduxUpdate,
    generateOBDPinData,
  };

  let response = null;
  try {
    response = yield call(generateOBDPinBit, generateOBDPinParams);
  } catch (e) {
    return null;
  }

  return response;
}

export function* validateOBDPin(input) {
  const reduxUpdate = {};
  const { actualStep } = yield select(uiNeedsStore);

  const {
    pinToValidate,
  } = input.payload;

  const validateOBDPinData = {
    pin: pinToValidate,
    verificarContacto: false,
  };

  const validateOBDPinParams = {
    ...input,
    reduxUpdate,
    validateOBDPinData,
  };

  let response = null;
  try {
    response = yield call(validateOBDPinBit, validateOBDPinParams);
  } catch (error) {
    console.log(error);
    if (error.response && error.response.error && error.response.error.codigoErrorNegocio === 'BACK-SEGURIDAD-006') {
      yield put(obdActions.validatePinMismatch());
    } else {
      yield put(obdActions.validatePinTimedOut());
    }
    return null;
  }
  if (response) {
    Modal.hide();
    yield put(apisNeedsActions.setActiveOBD());

    yield put(commonActions.setConfirmedStep({ stepId: actualStep.id, unblockedUIStep: true }));
  }

  return response;
}
